import { publicApi, siteApi } from "@api";
import useUserMode from "@hooks/useUserMode";
import logger from "@utils/logger";
import { GameModel } from "kz-ui-sdk";
import { useEffect, useMemo, useState } from "react";

const useGameList = (ids: string[]) => {
  const { isMember } = useUserMode();
  const [getGameList] = siteApi.useLazyGetGameListQuery();
  const [getPublicGameList] = publicApi.useLazyGetPublicGameListQuery();

  const fetcher = isMember ? getGameList : getPublicGameList;
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);

  const [data, setData] = useState<Record<string, GameModel>>({});

  useEffect(() => {
    if (!ids.length) {
      setFetched(true);
      return;
    }
    async function fetchData() {
      try {
        setLoading(true);
        const res = await Promise.all(
          ids.map((id) =>
            fetcher({
              query: {
                limit: 1,
                offset: 0,
                gameId: id,
              },
            }),
          ),
        );
        setData(
          res.reduce((acc: Record<string, GameModel>, curr) => {
            const game = curr?.data?.entries?.[0];
            if (game?.id) {
              acc[game.id] = game;
            }
            return acc;
          }, {}),
        );
      } catch (error) {
        logger._console.error(error);
      } finally {
        setFetched(true);
        setLoading(false);
      }
    }
    fetchData();
  }, [ids, fetcher]);

  return useMemo(() => ({ data, loading, fetched }), [data, loading, fetched]);
};

export default useGameList;
